import { GREEN_100, GREEN_300, GREY_600, RED_100, RED_200, antdColors } from 'constants/index';

import { PLATFORM_STATUS, SUPPORT_CASE_STATUS } from 'routes/constants/index';
import { isAdminPortal } from 'api';

export function getTwoToneColor(color: string) {
  return {
    backgroundColor: antdColors[color][0],
    color: antdColors[color][6],
  };
}

export function getOrderStatusColor(status: number): {
  backgroundColor: string;
  color: string;
} {
  if (
    status === PLATFORM_STATUS.SHIPPING ||
    status === PLATFORM_STATUS.RETURNING_OLD ||
    status === PLATFORM_STATUS.ARGUED
  ) {
    return getTwoToneColor('gold');
  }

  if (status === PLATFORM_STATUS.IN_CANCEL) {
    return getTwoToneColor('blue');
  }

  if (status === PLATFORM_STATUS.COMPLETED || status === PLATFORM_STATUS.RETURN_COMPLETED) {
    return getTwoToneColor('green');
  }

  return getTwoToneColor('red');
}

export function getSupportCaseStatusColor(status: number): {
  backgroundColor: string;
  color: string;
} {
  if (status === SUPPORT_CASE_STATUS.FINISH) {
    return {
      backgroundColor: GREEN_100,
      color: GREEN_300,
    };
  }

  if (status === SUPPORT_CASE_STATUS.PENDING_TRACKING) {
    if (!isAdminPortal) {
      return {
        backgroundColor: RED_100,
        color: RED_200,
      };
    }
    return {
      backgroundColor: 'white',
      color: GREY_600,
    };
  }

  if (!isAdminPortal) {
    return {
      backgroundColor: 'white',
      color: GREY_600,
    };
  }
  return {
    backgroundColor: RED_100,
    color: RED_200,
  };
}
